import { Box } from '@mui/material';

/**An MUI wrapped component that returns the RequiredMarker as a span with the correct color.
 * 
 * @returns 
 */
const RequiredMarker = () => {
    return (
        <Box
            component="span"
            sx={(theme) => {
                return { color: theme.palette.error.main };
            }}
        >
            *
        </Box>
    );
};

export default RequiredMarker;